import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css";

const Dashboard = () => {

  const [active, setActive] = useState("contact");
  const [careers, setCareers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [editContactData, setEditContactData] = useState(null);

  const API = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowDropdown(false);
    navigate("/admin/login");
  };

  useEffect(() => {
    fetch(`${API}/careers`)
      .then((res) => res.json())
      .then((data) => setCareers(data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    fetch(`${API}/contacts`)
      .then((res) => res.json())
      .then((data) => setContacts(data))
      .catch((err) => console.log(err));
  }, []);

  const deleteCareer = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await fetch(`${API}/careers/${id}`, { method: "DELETE" });
      setCareers(careers.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  const openEditModal = (item) => {
    setEditData({ ...item });
    setShowModal(true);
  };

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const saveEdit = async () => {
    try {
      await fetch(`${API}/careers/${editData.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          full_name: editData.full_name,
          email_id: editData.email_id,
          phone_number: editData.phone_number,
          experience: editData.experience,
          position_apply_for: editData.position_apply_for,
          location: editData.location,
        }),
      });
      setCareers(
        careers.map((c) =>
          c.id === editData.id ? { ...c, ...editData } : c
        )
      );
      setShowModal(false);
      setEditData(null);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteContact = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await fetch(`${API}/contacts/${id}`, { method: "DELETE" });
      setContacts(contacts.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  const openEditContactModal = (item) => {
    setEditContactData({ ...item });
    setShowContactModal(true);
  };

  const handleContactChange = (e) => {
    setEditContactData({ ...editContactData, [e.target.name]: e.target.value });
  };

  const saveContactEdit = async () => {
    try {
      await fetch(`${API}/contacts/${editContactData.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: editContactData.first_name,
          last_name: editContactData.last_name,
          phone_number: editContactData.phone_number,
          work_email: editContactData.work_email,
          company_name: editContactData.company_name,
          location: editContactData.location,
          requirements: editContactData.requirements,
        }),
      });
      setContacts(
        contacts.map((c) =>
          c.id === editContactData.id ? { ...c, ...editContactData } : c
        )
      );
      setShowContactModal(false);
      setEditContactData(null);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="dashboard-container">

      {/* Sidebar */}
      <div className="sidebar">
        <h2 className="dash-logo">Admin Panel</h2>
        <ul>
          <li onClick={() => setActive("contact")}>Contact Info</li>
          <li onClick={() => setActive("careers")}>Careers Info</li>
        </ul>
      </div>

      {/* Main Dashboard */}
      <div className="dashboard-main">

        {/* TOP BAR */}
        <div className="topbar">
          <div className="topbar-right">
            <button className="logout-btn" onClick={handleLogout}>
              <span className="logout-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
              </span>
              Logout
            </button>
          </div>
        </div>

        {/* CONTACT INFO */}
        {active === "contact" && (
          <div>
            <h1>Contact Information</h1>
            <div className="table-wrapper">
              <table className="career-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Location</th>
                    <th>Requirements</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.first_name}</td>
                      <td>{item.last_name}</td>
                      <td>{item.phone_number}</td>
                      <td>{item.work_email}</td>
                      <td>{item.company_name}</td>
                      <td>{item.location}</td>
                      <td>{item.requirements}</td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="edit-btn"
                            onClick={() => openEditContactModal(item)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                            </svg>
                            Edit
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => deleteContact(item.id)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="3 6 5 6 21 6"/>
                              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                              <path d="M10 11v6M14 11v6"/>
                              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                            </svg>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* CAREERS INFO */}
        {active === "careers" && (
          <div>
            <h1>Careers Information</h1>
            <div className="table-wrapper">
              <table className="career-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Experience</th>
                    <th>Position</th>
                    <th>Location</th>
                    <th>Resume</th>
                    <th>Created</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {careers.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.full_name}</td>
                      <td>{item.email_id}</td>
                      <td>{item.phone_number}</td>
                      <td>{item.experience}</td>
                      <td>{item.position_apply_for}</td>
                      <td>{item.location}</td>
                      <td>
                        <a
                          href={`${API}/uploads/${item.resume_pdf}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          View
                        </a>
                      </td>
                      <td>{item.created_at}</td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="edit-btn"
                            onClick={() => openEditModal(item)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                            </svg>
                            Edit
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => deleteCareer(item.id)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="3 6 5 6 21 6"/>
                              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                              <path d="M10 11v6M14 11v6"/>
                              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                            </svg>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>

      {/* EDIT CAREER MODAL */}
      {showModal && editData && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Edit Career</h2>
            <div className="modal-field">
              <label>Full Name</label>
              <input name="full_name" value={editData.full_name} onChange={handleChange} />
            </div>
            <div className="modal-field">
              <label>Email</label>
              <input name="email_id" value={editData.email_id} onChange={handleChange} />
            </div>
            <div className="modal-field">
              <label>Phone</label>
              <input name="phone_number" value={editData.phone_number} onChange={handleChange} />
            </div>
            <div className="modal-field">
              <label>Experience (years)</label>
              <input name="experience" value={editData.experience} onChange={handleChange} />
            </div>
            <div className="modal-field">
              <label>Position</label>
              <input name="position_apply_for" value={editData.position_apply_for} onChange={handleChange} />
            </div>
            <div className="modal-field">
              <label>Location</label>
              <input name="location" value={editData.location} onChange={handleChange} />
            </div>
            <div className="modal-actions">
              <button className="save-btn" onClick={saveEdit}>Save</button>
              <button className="cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT CONTACT MODAL */}
      {showContactModal && editContactData && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Edit Contact</h2>
            <div className="modal-field">
              <label>First Name</label>
              <input name="first_name" value={editContactData.first_name} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Last Name</label>
              <input name="last_name" value={editContactData.last_name} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Phone</label>
              <input name="phone_number" value={editContactData.phone_number} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Email</label>
              <input name="work_email" value={editContactData.work_email} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Company</label>
              <input name="company_name" value={editContactData.company_name} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Location</label>
              <input name="location" value={editContactData.location} onChange={handleContactChange} />
            </div>
            <div className="modal-field">
              <label>Requirements</label>
              <input name="requirements" value={editContactData.requirements} onChange={handleContactChange} />
            </div>
            <div className="modal-actions">
              <button className="save-btn" onClick={saveContactEdit}>Save</button>
              <button className="cancel-btn" onClick={() => setShowContactModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Dashboard;
